import identity from "lodash/identity";
import { Api } from "@core/api/api";
import { BrowserLocalStorage } from "@core/localStorage/storage";
import { Services } from "@core/servicesContext";
// import { AdminContentApi } from "../domain/admin/adminContentApi";
// import { AdminContentService } from "../domain/admin/adminContentService";
import { StreamChat } from "stream-chat";
import { Environment } from "@core/config/environment";
import { ApplicationApi } from "@domain/application/applicationApi";
import { ApplicationService } from "@domain/application/applicationService";
import { BrowserAuthService } from "@domain/auth/browserAuthService";
import { CarouselApi } from "@domain/carousel/carouselsApi";
import { CarouselService } from "@domain/carousel/carouselService";
import { CurrencyApi } from "@domain/currency/currencyApi";
import { CurrencyService } from "@domain/currency/currencyService";
import { CurrentProfileApi } from "@domain/currentProfile/currentProfileApi";
import { CurrentProfileService } from "@domain/currentProfile/currentProfileService";
import { BrowserFacebookService } from "@domain/currentProfile/facebookService/browserFacebookService";
import { BrowserInstagramService } from "@domain/currentProfile/instagramService/browserInstagramService";
import { BrowserLinkedinService } from "@domain/currentProfile/linkedinService/browserLinkedinService";
import { BrowserTwitterService } from "@domain/currentProfile/twitterService/browserTwitterService";
import { BrowserWhatsappService } from "@domain/currentProfile/whatsappService/browserWhatsappService";
import { ExperienceApi } from "@domain/experience/experienceApi";
import { ExperienceService } from "@domain/experience/experienceService";
import { FilterApi } from "@domain/filter/filterApi";
import { FilterService } from "@domain/filter/filterService";
import { GroupApi } from "@domain/group/groupApi";
import { GroupService } from "@domain/group/groupService";
import { WorkspaceApi } from "@domain/group/workspace/workspaceApi";
import { WorkspaceService } from "@domain/group/workspace/workspaceService";
import { AppInitialState } from "@domain/initialState/appInitialState";
import { LivecourseApi } from "@domain/livecourse/livecourseApi";
import { LivecourseService } from "@domain/livecourse/livecourseService";
import { ArticleApi } from "@domain/lms/article/articleApi";
import { ArticleService } from "@domain/lms/article/articleService";
import { CourseApi } from "@domain/lms/course/courseApi";
import { CourseService } from "@domain/lms/course/courseService";
import { QuizApi } from "@domain/lms/quiz/quizApi";
import { QuizService } from "@domain/lms/quiz/quizService";
import { MediaApi } from "@domain/media/mediaApi";
import { MediaService } from "@domain/media/mediaService";
import { MessagingApi } from "@domain/messaging/messagingApi";
import { MessagingService } from "@domain/messaging/messagingService";
import { NotificationApi } from "@domain/notification/notificationApi";
import { NotificationService } from "@domain/notification/notificationService";
import { OrganizationApi } from "@domain/organization/organizationApi";
import { OrganizationService } from "@domain/organization/organizationService";
import { TrackApi } from "@domain/organization/track/trackApi";
import { TrackService } from "@domain/organization/track/trackService";
import { PostApi } from "@domain/post/postApi";
import { PostService } from "@domain/post/postService";
import { PrivacyService } from "@domain/privacy/privacyService";
import { SearchService } from "@domain/search/searchService";
import { SupportApi } from "@domain/support/supportApi";
import { SupportService } from "@domain/support/supportService";
import { TagsApi } from "@domain/tags/tagsApi";
import { TagsService } from "@domain/tags/tagsService";
import { LocalTrackingService } from "@domain/tracking/trackingService";
import { WebTrackingService } from "@domain/tracking/webTrackingService";
import { UserApi } from "@domain/user/userApi";
import { UserService } from "@domain/user/userService";
import { UserKycApi } from "@domain/userKyc/userKycApi";
import { UserKycService } from "@domain/userKyc/userKycService";
import { WalletApi } from "@domain/wallet/walletApi";
import { WalletService } from "@domain/wallet/walletService";

export function initializeBrowserServices(initialState?: AppInitialState): Services {
	const authService = new BrowserAuthService();
	const api = new Api(authService);
	const currentProfileApi = new CurrentProfileApi(api);
	const currentProfileService = new CurrentProfileService(
		currentProfileApi,
		authService,
		initialState?.initializationState
	);
	const courseApi = new CourseApi(api);
	const articleApi = new ArticleApi(api);
	const applicationApi = new ApplicationApi(api);
	const groupApi = new GroupApi(api);
	const walletApi = new WalletApi(api);
	const courseService = new CourseService(courseApi, currentProfileService, initialState?.courses);
	const articleService = new ArticleService(articleApi, currentProfileService, initialState?.articles);
	const applicationService = new ApplicationService(applicationApi, initialState?.application);

	const groupService = new GroupService(groupApi, currentProfileService, initialState?.groups);
	const walletService = new WalletService(walletApi, initialState?.wallet);
	const facebookService = new BrowserFacebookService();
	const twitterService = new BrowserTwitterService();
	const whatsappService = new BrowserWhatsappService();
	const linkedinService = new BrowserLinkedinService();
	const instagramService = new BrowserInstagramService();
	const userApi = new UserApi(api);
	const trackApi = new TrackApi(api);
	const trackService = new TrackService(trackApi);
	const organizationApi = new OrganizationApi(api);
	const organizationService = new OrganizationService(organizationApi, trackService, initialState?.organizations);
	const carouselApi = new CarouselApi(api);
	const carouselService = new CarouselService(carouselApi, currentProfileService);
	const workspaceApi = new WorkspaceApi(api);
	const workspaceService = new WorkspaceService(workspaceApi);
	const quizApi = new QuizApi(api);

	const currencyApi = new CurrencyApi(api);

	const userService = new UserService(
		userApi,
		organizationApi,
		groupApi,
		currentProfileService,
		organizationService,
		groupService,
		quizApi,
		initialState?.profiles
	);
	const mediaApi = new MediaApi(api);
	const mediaService = new MediaService(mediaApi);
	const filterApi = new FilterApi(api);
	const filterService = new FilterService(filterApi);
	const postApi = new PostApi(api);
	const quizService = new QuizService(quizApi, currentProfileService);
	const postService = new PostService(
		postApi,
		userService,
		organizationService,
		groupService,
		quizService,
		currentProfileService
	);
	const queryStorage = new BrowserLocalStorage<string[]>("queries", identity, identity);
	const trackingService =
		window.location.hostname === "localhost"
			? new LocalTrackingService()
			: new WebTrackingService(currentProfileService);
	const experienceApi = new ExperienceApi(api);
	const experienceService = new ExperienceService(experienceApi, currentProfileService);
	const notificationApi = new NotificationApi(api);
	const notificationService = new NotificationService(notificationApi);
	const searchService = new SearchService(
		userService,
		courseService,
		articleService,
		quizService,
		organizationService,
		groupService,
		carouselService,
		queryStorage
	);
	const supportApi = new SupportApi(api);
	const supportService = new SupportService(supportApi);
	const privacyStorage = new BrowserLocalStorage<boolean>("privacy", identity, identity);
	const privacyService = new PrivacyService(privacyStorage);

	// const adminApi = new Api(authService, "admin");

	const liveCourseApi = new LivecourseApi(api);

	// const adminContentApi = new AdminContentApi(adminApi);
	// const adminContentService = new AdminContentService(adminContentApi);
	const livecourseService = new LivecourseService(liveCourseApi, userApi);
	const tagsApi = new TagsApi(api);

	const tagsService = new TagsService(tagsApi);

	const currencyService = new CurrencyService(currencyApi);

	const userKycApi = new UserKycApi(api);
	const userKycService = new UserKycService(userKycApi);
	const messagingApi = new MessagingApi(api);
	const messagingService = new MessagingService(messagingApi);
	const apiKey = Environment.GETSTREAM_API_KEY;
	const chatClient = apiKey ? StreamChat.getInstance(apiKey as string) : undefined;

	const services: Services = {
		authService,
		currentProfileService,
		courseService,
		facebookService,
		instagramService,
		twitterService,
		linkedinService,
		whatsappService,
		searchService,
		userService,
		mediaService,
		postService,
		organizationService,
		trackingService,
		experienceService,
		notificationService,
		quizService,
		trackService,
		groupService,
		workspaceService,
		privacyService,
		supportService,
		// adminContentService,
		articleService,
		livecourseService,
		tagsService,
		carouselService,
		applicationService,
		filterService,
		currencyService,
		userKycService,
		walletService,
		messagingService,
		chatClient,
	};

	return services;
}
